import { render, staticRenderFns } from "./SuperAdminProfile.vue?vue&type=template&id=fc00cc10&scoped=true&"
import script from "./SuperAdminProfile.vue?vue&type=script&lang=js&"
export * from "./SuperAdminProfile.vue?vue&type=script&lang=js&"
import style0 from "./SuperAdminProfile.vue?vue&type=style&index=0&id=fc00cc10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc00cc10",
  null
  
)

export default component.exports